import { t } from "@/lib/i18n";

const STYLES = {
  blocked: "bg-red-600 text-white border-red-600",
  open: "bg-emerald-50 text-emerald-700 border-emerald-200",
  matched: "bg-slate-900 text-amber-400 border-slate-900",
  completed: "bg-emerald-600 text-white border-emerald-600",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  shipper_accepted: "bg-blue-50 text-blue-700 border-blue-200",
  confirmed: "bg-emerald-600 text-white border-emerald-600",
  rejected: "bg-red-50 text-red-700 border-red-200",
  withdrawn: "bg-slate-100 text-slate-500 border-slate-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  declined: "bg-red-50 text-red-700 border-red-200",
};
const LABELS = { shipper_accepted: "Awaiting transporter", pending: "Pending" };

const TRUCK = {
  Dropside: "bg-blue-50 text-blue-700 border-blue-200",
  "Side Tipper": "bg-amber-50 text-amber-700 border-amber-200",
  "Bottom Discharger": "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function StatusBadge({ status, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded border ${STYLES[status] || STYLES.pending}`}>
      {t(LABELS[status] || status?.replace("_", " "))}
    </span>
  );
}

export function TruckBadge({ type }) {
  return (
    <span className={`inline-flex items-center text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded border ${TRUCK[type] || "bg-slate-50 text-slate-700 border-slate-200"}`}>
      {t(type)}
    </span>
  );
}
